import { inputLabelClasses, TextField, useTheme } from "@mui/material";

export default function CodeInput(props) {
  const { register, position, handleFill, handlePaste, handleDelete, disabled } =
    props;
  const theme = useTheme();

  return (
    <TextField
      autoFocus={position === "code1" ? true : false}
      // focused={position === "code" + currentFocus ? true : false}
      required
      type="number"
      disabled={disabled}
      {...register(position)}
      margin="dense"
      id={position}
      variant="outlined"
      onChange={handleFill}
      onPaste={handlePaste}
      onKeyDown={handleDelete}
      InputProps={{
        inputProps: {
          minLength: 1,
          maxLength: 1,
        },
      }}
      InputLabelProps={{
        style: {
          color: "#a6b1bb",
        },
      }}
      sx={{
        input: {
          color: "black",
          textAlign: "center",
        },
        "& .MuiOutlinedInput-root": {
          borderRadius: "8px",
        },
        fieldset: {
          borderColor: theme.palette.grey[500_32],
          [`&.${inputLabelClasses.shrink}`]: {
            borderColor: theme.palette.secondary.main,
          },
          "&:focus": {
            borderColor: theme.palette.secondary.main,
          },
        },
        "& .Mui-focused fieldset": {
          borderColor: `${theme.palette.secondary.main} !important`,
        },
        flex: 1,
        minWidth: 0,
        maxWidth: "56px",
      }}
    />
  );
}
